
define('modules/application/wizard/steps/zoneStep/complexZoneStep/automationSimpleZoneStep/zoneDetailView',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  // Classes
  "../zoneDetailView",
  "../../../../classes/gaugesAndInterfaces",
  "../../../../classes/controlledLoads",
  "../../../../classes/commands",
  "../../../../classes/traditional",
  "../../../../classes/lightPoints",
  "../../../../classes/engines",
  "../../../../classes/commandPoints",
  "../../../../classes/advancedCommands",
  "../../../../classes/webServer",
  "../../../../classes/integrationDevices",
  "../../../../classes/zigbeeRadio",
  "../../../../classes/automationRemoteControls",
  "../../../../classes/scenariosCommands",

  //Widgets
  "../../../../../widgets/audioVideoConsumptionIndicator"
],

function(
  app,
  Backbone,
  jQueryUi,
  ZoneDetailView,
  gaugesAndInterfaces,
  controlledLoads,
  commands,
  traditional,
  lightPoints,
  engines,
  commandPoints,
  advancedCommands,
  webServer,
  integrationDevices,
  zigbeeRadio,
  automationRemoteControls,
  scenariosCommands,
  audiovideoConsumptionIndicator) {

  //Automation
  // Creating a single zone model
  var automationSimpleZoneDetailView               = ZoneDetailView.extend({
    initialize   : function() {
      this.addConstructors();
      var that = this,
          len  = this.options.sections.length,
          i    = 0;

      this.model.get("stepEventAggregator").unbind("order:changed",  this.orderChangedEventHandler);
      this.model.get("stepEventAggregator").bind("order:changed",    this.orderChangedEventHandler, this);

      this.model.get("stepEventAggregator").unbind("render:requested", this.requestRenderEventHandler);
      this.model.get("stepEventAggregator").bind("render:requested",   this.requestRenderEventHandler, this);


      for(i=0;i<len;i++) {
        var classToInstance      = this.sectionInstancer(this.options.sections[i]);
        var zoneEventAggregator  = this.model.get("zoneEventAggregator");
        var obj                  = classToInstance;
        var objModel             = null;

        var modelInstance        = null;
        var modelName            = this.options.sections[i].name + "Model";
        if (this.model.get(modelName)===undefined)
        {
          modelInstance = new obj.Model({
            stepEventAggregator :  this.model.stepEventAggregator,
            zoneEventAggregator :  zoneEventAggregator,
            zoneNumber          :  this.model.get("number")
          });
          this.model.set(modelName, modelInstance);
        }
        else if (this.model.get(modelName).attributes) {
          objModel = this.model.get(modelName);
        }
        else {
          modelInstance = new obj.Model(_.extend({
            stepEventAggregator :  this.model.stepEventAggregator,
            zoneEventAggregator :  zoneEventAggregator,
            zoneNumber          :  this.model.get("number")
          }, this.model.get(modelName)));
          this.model.set(modelName, modelInstance);
        }

        objModel = this.model.get(modelName);

        this.insertView(".accordionView", new obj.Views.titleBar ({ model   :   objModel }));
        this.insertView(".accordionView", new obj.Views.content  ({ model   :   objModel }));
      }
    },
    addConstructors : function() {
      this.consumptionIndicator = audiovideoConsumptionIndicator;
    },
    sectionInstancer        : function(section)   {
      switch(section.name)
      {
        case "gaugesAndInterfaces"       : return gaugesAndInterfaces;
        case "controlledLoads"           : return controlledLoads;
        case "commands"                  : return commands;
        case "traditional"               : return traditional;
        case "lightPoints"               : return lightPoints;
        case "engines"                   : return engines;
        case "commandPoints"             : return commandPoints;
        case "advancedCommands"          : return advancedCommands;
        case "webServer"                 : return webServer;
        case "zigbeeRadio"               : return zigbeeRadio;
        case "integrationDevices"        : return integrationDevices;
        case "automationRemoteControls"  : return automationRemoteControls;
        case "scenariosCommands"         : return scenariosCommands;
      }
    },

    beforeRender : function() {
      var consumptionIndicatorModel;

      //Adding current consumption indicator
      if (BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel"))
        consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
      else
        consumptionIndicatorModel = new this.consumptionIndicator.Model();
      
      //this.insertView(".indicators", new this.consumptionIndicator.View({model : consumptionIndicatorModel}));
    }
  });

  // Required, return the module for AMD compliance
  return automationSimpleZoneDetailView;
});